import { styled } from '@mui/material/styles';
import { tabsClasses } from '@mui/material/Tabs';
import { MuiTabs } from '../../../../../modules/material';
import { TabsProps } from './index';

export const StyledTabs = styled(MuiTabs)<Omit<TabsProps, 'defaultValue'>>(
  ({ theme }) => {
    return {
      minHeight: 'initial',
      borderRadius: 'var(--payment-component-tabs-border-radius)',
      backgroundColor: theme.palette.neutral[100],
      padding: 'var(--payment-component-tabs-padding)',

      [`& .${tabsClasses.indicator}`]: {
        display: 'none',
      },
    };
  },
);
